import { requiredIf } from "../common/proptypes";
/**
 * Checks if remote pagination is enabled.
 * @param {PropType} type prop type
 * @param {String} name prop name
 */

export function requiredIfRemotePagination(type, name) {
  return requiredIf(type, (props, propName) => {
    const {
      remote,
      paginator
    } = props;
    const value = props[propName];
    return (remote || paginator && paginator.remote) && (
    /**
     * While validating `page` or `itemsPerPage` or `totalItems` props,
     * it can accept `0` also as valid value. When `onPagination` is being
     * validated, it needs to accept `function` as valid value. So, to handle
     * both the scenarios, checking its value with `null` or `undefined` here.
     */
    value === null || value === undefined) // eslint-disable-line no-undefined
    ;
  }, "if `paginator.remote` is `true`", name);
}
/**
 * It validates that the control props are passed when `paginator.remote` is `true`.
 * Note: This can't be done with `PropTypes` when using `oneOfType`.
 * TODO: Find a way to do this with `ProTypes` validations
 */

export function validatePropsForRemotePagination(props) {
  const {
    paginator,
    selectable,
    expandable
  } = props;
  const isNotProd = process.env.NODE_ENV !== "production";
  const remotePaginationEnabled = paginator && paginator.remote;

  if (remotePaginationEnabled && isNotProd) {
    if (selectable && !selectable.selectedItems) {
      throw new Error(`Failed prop type: The prop \`selectable.selectedItems\` is required in \`ListView\`
        if \`paginator.remote\` is \`true\``);
    }

    if (expandable && !expandable.expandedItems) {
      throw new Error(`Failed prop type: The prop \`expandable.expandedItems\` is required in \`ListView\`
        if \`paginator.remote\` is \`true\``);
    }
  }
}
/**
 * It validates that the callbacks for the control props are passed.
 * Note: This can't be done with `PropTypes` when using `oneOfType`.
 * TODO: Find a way to do this with `ProTypes` validations
 */

export function validateControlPropsCallbacks(props) {
  const {
    selectable,
    expandable
  } = props;
  const isNotProd = process.env.NODE_ENV !== "production";

  if (isNotProd && selectable && selectable.selectedItems && !selectable.onSelectedChange) {
    throw new Error(`Failed prop type: The prop \`selectable.onSelectedChange\` is required in \`ListView\` if \`selectable.selectedItems\` is passed`);
  }

  if (isNotProd && expandable && expandable.expandedItems && !expandable.onExpandedChange) {
    throw new Error(`Failed prop type: The prop \`expandable.onExpandedChange\` is required in \`ListView\` if \`expandable.expandedItems\` is passed`);
  }
}